<template>
  <!-- 首页 -->
  <div>
    <div class="swiperBox" style="width: 1100px;">
      <!-- 轮播图 -->
      <Swiper :autoplay="true" :duration="3000" :initial="1" :hasDot="false">
        <SwiperItem v-for="(item, index) in swiperList" :key="index">
          <a :href="item.article_url">
            <img style="width: 100%; height: 100%;" :src="item.origin_thumbnail_url" alt="esg">
          <div class="desc">{{ item.title }}</div>
          </a>
        </SwiperItem>
      </Swiper>
      <div class="right">
        <a href="https://www.nbd.com.cn/corp/2022esg/dist/#/details">
          <img class="i1" src="../assets/imgs/homePage/xingdongpai.jpg" alt="">
        </a>
        <div class="bottom">
          <a href="https://www.nbd.com.cn/corp/20220622brand-value/dist/index.html#/valueList">
            <img src="../assets/imgs/homePage/top100.jpg" alt="">
          </a>
          <a href="http://www.nbd.com.cn/corp/greencapital/index.html#/">
            <img src="../assets/imgs/homePage/lvsezhoubao.jpg" alt="">
          </a>
        </div>
      </div>
    </div>
    <!-- 横向滚动列表 -->
    <RowList :list="rowList"></RowList>
    <!-- 竖向列表 -->
    <div class="cloumnList" style="width: 1100px;">
      <div class="section">
        <columnList :list="baodaoData" type="/report" :isHome="true">
          <template v-slot:name>
            报道
          </template>
        </columnList>
        <columnList :list="guanchaData" type="/observe" :isHome="true">
          <template v-slot:name>
            观察
          </template>
        </columnList>
      </div>
      <div class="aside">
        <columnList :list="anliData" type="/case" :isHome="true">
          <template v-slot:name>
            案例
          </template>
        </columnList>
        <columnList :list="huodongData" type="/activity" :isHome="true">
          <template v-slot:name>
            活动
          </template>
        </columnList>
        <columnList :list="ketangData" type="/classroom" :isHome="true" :isClassroom="true">
          <template v-slot:name>
            课堂
          </template>
        </columnList>
        <columnList :list="zhuantiData" type="/specialTopic" :isHome="true">
          <template v-slot:name>
            专题
          </template>
        </columnList>
      </div>
    </div>
  </div>
</template>
  
<script>
import Swiper from '@/components/homePage/swiper.vue';
import SwiperItem from '@/components/homePage/swiperItem.vue';
import RowList from '@/components/homePage/rowList.vue';
import columnList from '../components/common/columnList.vue';
export default {
  components: {
    Swiper,
    RowList,
    SwiperItem,
    columnList
  },
  data() {
    return {
      swiperList: [],
      rowList:[],
      baodaoData: [],
      guanchaData: [],
      anliData: [],
      huodongData: [],
      zhuantiData: [],
      ketangData: [],
    };
  },
  created() {
    const that = this;
    that.$http
      .get(//轮播图
        'https://www.nbd.com.cn/columns/2035/articles_list.json?simple_info=1&per=3&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data,989);
        that.swiperList = res.data
      });
      that.$http
      .get(//横向列表
        'https://www.nbd.com.cn/columns/2034/articles_list.json?simple_info=1&per=200&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data,9889);
        that.rowList = res.data
      });
    that.$http
      .get(//课堂
        'https://www.nbd.com.cn/columns/1843/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data);
        that.ketangData = res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      });
    that.$http
      .get(//活动
        'https://www.nbd.com.cn/columns/1805/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data);
        that.huodongData =
          res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      });
    that.$http
      .get(//报道
        'https://www.nbd.com.cn/columns/1803/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data);
        that.baodaoData = res.data.length > 6 ? res.data.slice(0, 6) : res.data;
      });

    that.$http
      .get(//观察
        'https://www.nbd.com.cn/columns/1653/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        that.guanchaData =
          res.data.length > 6 ? res.data.slice(0, 6) : res.data;
      });

    that.$http
      .get(//案例
        'https://www.nbd.com.cn/columns/1804/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data);
        that.anliData = res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      });

    that.$http
      .get(//专题
        'https://www.nbd.com.cn/columns/1818/articles_list.json?simple_info=1&per=10&t=' + (Math.floor(new Date().getTime()/100000))
      )
      .then(function (res) {
        console.log(res.data);
        that.zhuantiData =
          res.data.length > 3 ? res.data.slice(0, 3) : res.data;
      });
  },
};
</script>
  
<style lang="scss" scoped>
.swiperBox {
  min-width: 1100px;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;

  .desc {
    width: 100%;
    height: 40px;
    background-color: rgba(0, 0, 0, .7);
    position: absolute;
    bottom: 0;
    left: 0;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    line-height: 40px;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .right {
    width: 572px;
    height: 307px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .i1 {
      width: 100%;
      height: 148px;
    }

    .bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;

      img {
        width: 280px;
        height: 145px;
      }
    }
  }
}

.cloumnList {
  min-width: 1100px;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;

  .section {
    width: 64%;
  }

  .aside {
    width: 32%;
  }
}
</style>
  